export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/USAToday.81957eeb.svg","height":28,"width":151};